import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectorDataPointsExhibitionType, selectorFiltersValues } from '../../../../reducers';
import { selectorPriceManagerMoreFiltersValues } from '../../../../reducers/gerenciadorPrecos/filters/moreFilters';
import { selectorPagination } from '../../../../reducers/gerenciadorPrecos/pagination';
import { selectorQuickActionFilters } from '../../../../reducers/gerenciadorPrecos/quickActionsFilter';
import { selectorSort } from '../../../../reducers/gerenciadorPrecos/sort';
import { selectorSelectedClusters, useClusterStore } from '../../../../store/useClusterStore';
import { useStoreTypeStore } from '../../../../store/useStoreTypeStore';
import {
  GET_MODEL_GERENCIADOR_FILTROS,
  GET_MODEL_GERENCIADOR_PAGINATION,
  GET_MODEL_GERENCIADOR_QUICK_ACTION_FILTERS,
  GET_MODEL_GERENCIADOR_SORT,
} from '../utils';

export const usePriceManagerDatapointsModel = () => {
  const filters = useSelector(selectorFiltersValues);
  const sort = useSelector(selectorSort);
  const pagination = useSelector(selectorPagination);
  const quickActionsFilter = useSelector(selectorQuickActionFilters);
  const moreFiltersValue = useSelector(selectorPriceManagerMoreFiltersValues);
  const datapointExhibitionType = useSelector(selectorDataPointsExhibitionType);
  const selectedClusters = useClusterStore(selectorSelectedClusters);
  const selectedStoreTypes = useStoreTypeStore(state => state.selectedStoreTypes);

  return useMemo(() => {
    const isClusterMode = datapointExhibitionType === 'PRODUCT_CLUSTER' || datapointExhibitionType === 'PRODUCT_CLUSTER_FAMILY';

    return {
      ...GET_MODEL_GERENCIADOR_FILTROS(filters),
      ...GET_MODEL_GERENCIADOR_SORT(sort),
      ...GET_MODEL_GERENCIADOR_PAGINATION(pagination),
      ...GET_MODEL_GERENCIADOR_QUICK_ACTION_FILTERS(quickActionsFilter, sort.priceType),
      ...moreFiltersValue,
      datapointExhibitionType,
      ...(isClusterMode && { clusters: selectedClusters }),
      storeType: selectedStoreTypes,
    };
  }, [filters, sort, pagination, quickActionsFilter, moreFiltersValue, datapointExhibitionType, selectedClusters, selectedStoreTypes]);
};

export type PriceManagerDatapointsModel = ReturnType<typeof usePriceManagerDatapointsModel>;
